import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { EyeFilled } from "@ant-design/icons";
import Create from "../create";

export default ({ detail }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <a onClick={() => setOpen(true)}>
        <EyeFilled style={{ marginRight: 8 }} onClick={() => {}} />
        查看
      </a>
      <Modal
        open={open}
        title={"查看详情"}
        width={800}
        onCancel={() => {
          setOpen(false);
        }}
        onOk={() => {
          setOpen(false);
        }}
      >
        <Create detail={detail} mode="detail" />
      </Modal>
    </>
  );
};
